import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import YourVideos from '../components/home/YourVideos';

const VideosPage: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100vw',
        overflowX: 'hidden',
        mx: 'auto',
        px: { xs: 1, sm: 2 },
        py: 2,
        boxSizing: 'border-box',
      }}
    >
      <Typography variant="h5" sx={{ mb: 2 }}>
        Videos
      </Typography>
      <YourVideos />
    </Box>
  );
};

export default VideosPage;
